import { trackConfig, type IFramework } from '@/framework';
import { LayerType, type ILayerProps, type ITextLayerProps, type ITexture } from '@/version-types';
import { pushHistory, updateLayer, validateInputLayer } from '../utils';

const TEXTURE_FUNC_ID = trackConfig[LayerType.TEXT_LAYER].texture;

export class FillTexture {
    constructor(private framework: IFramework) {}

    private prepare(prevLayer: ILayerProps, texture: ITexture): ILayerProps {
        const prevLayerData = prevLayer.data as ITextLayerProps;
        const nextLayerData: ITextLayerProps = {
            ...prevLayerData,
            texture,
            textGradient: null,
            lineThrough: false,
            underline: false,
        };
        return { ...prevLayer, data: nextLayerData };
    }

    private setGroup(prevLayer: ILayerProps, texture: ITexture) {
        const children = prevLayer.children;
        if (children.length === 0) return;

        const layers = children.map((child) => this.prepare(child, texture));

        const nextLayer = { ...prevLayer, children: layers };
        updateLayer(this.framework, nextLayer);
        pushHistory(this.framework, prevLayer, nextLayer, TEXTURE_FUNC_ID);

        return nextLayer;
    }

    private setSingle(prevLayer: ILayerProps, texture: ITexture) {
        if ((prevLayer.data as ITextLayerProps).shapeExtension) return;

        const nextLayer = this.prepare(prevLayer, texture);

        updateLayer(this.framework, nextLayer);
        pushHistory(this.framework, prevLayer, nextLayer, TEXTURE_FUNC_ID);

        return nextLayer;
    }

    setFillTexture(layerID: string, texture: ITexture) {
        const prevLayer = this.framework.service.flatLayer.getLayer(layerID, true);
        if (!validateInputLayer(prevLayer)) return;

        if (prevLayer.layerType === LayerType.GROUP_LAYER) return this.setGroup(prevLayer, texture);
        return this.setSingle(prevLayer, texture);
    }
}
